export default "__VITE_ASSET__C3jggH_p__"